import { useMemo } from "react";

import { BucketOfLearninRow } from "./BucketOfLearninRow";
import { useLevelContext } from "sj-ui-toolkit/src/atlas/contexts/Level/LevelContextProvider";

export const QuestBucket = ({ currentQuests = [] }) => {
  const { quests, isLoadingQuests } = useLevelContext();

  const notEnrolledQuests = useMemo(() => {
    const enrolledRoleIds = new Set(currentQuests.map(q => q.id));
    return quests.filter(quest => !enrolledRoleIds.has(quest.role?.id));
  }, [quests, currentQuests]);

  // viewAllHref is ignored by the legacy row when the upgraded UX flag is off.
  return (
    <div className="my-8">
      <BucketOfLearninRow
        key="quest-row"
        id="quest"
        name="Quests"
        variant="indigo"
        loading={isLoadingQuests}
        learnins={notEnrolledQuests}
        pathType="Quest"
        viewAllHref="/quests"
      />
    </div>
  );
};
